import React from 'react';
import { UxDataGroupTabs } from 'botbit-ui-components'; 
import ReviewsChart from './ReviewsChart';
import ReviewsByStars from './ReviewsByStars';
import { useState } from 'react';
import { useEffect } from 'react';
import translate from '../../../config/translations/translate';
import Spinner from '../../../commons/components/utils/spinner/Spinner';

const ReputationCharts = ({ storeId, selectedPeriod, t}) => {

  const [dataAvailable, setDataAvailable] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    setDataAvailable(true);
    
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, [storeId, selectedPeriod && selectedPeriod.value ? selectedPeriod.value : selectedPeriod]);

  return (
    <div className="reputation-charts-container">
      <UxDataGroupTabs 
        tabs={[
          {
            id: 'reviews-over-time',
            label: 'Evolución de Reviews',
            content: isLoading ? (
              <div className="chart-section" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '500px', backgroundColor: '#FFFFFF'}}>
                <Spinner />
              </div>
            ) : !dataAvailable ? (
              <div className="chart-section" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '500px', backgroundColor: '#FFFFFF'}}> 
                <h2 style={{color: '#666666', marginTop: '0px'}}>{t('noDataAvailable')} </h2>
              </div>
            ) : (
              <div className="chart-section">
                <ReviewsChart 
                  storeId={storeId} 
                  selectedPeriod={selectedPeriod} 
                  setDataAvailable={setDataAvailable}
                />
              </div>
            )
          },
          {
            id: 'reviews-by-stars',
            label: 'Reviews por Estrellas',
            content: isLoading ? (
              <div className="chart-section" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '500px', backgroundColor: '#FFFFFF'}}>
                <Spinner />
              </div>
            ) : !dataAvailable ? (
              <div className="chart-section" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '500px', backgroundColor: '#FFFFFF'}}> 
                <h2 style={{color: '#666666', marginTop: '0px'}}>{t('noDataAvailable')} </h2>
              </div>
            ) : (
              <div className="chart-section">
                <ReviewsByStars 
                  storeId={storeId}
                  selectedPeriod={selectedPeriod}
                  setDataAvailable={setDataAvailable}
                />
              </div>
            )
          }
        ]}
      />
    </div>
  );
};

ReputationCharts.translations = {
  noDataAvailable: {
    es: 'No hay datos disponibles para esta tienda y período.',
    en: 'No data available for this store and period.'
  }
}

export default translate(ReputationCharts);